import scenario from "../scenario";

const models = `${process.env.VUE_APP_URL}/api/v1/models`;

export default {
  namespaced: true,
  state: {
    formData: {
      name: "",
      modelId: null
    },
    modelToCopy: {},
    scenarioOptions: [],

    // model copy details
    scenarioModelCopyDetails: [],
    modelCopyList: [],
  },
  mutations: {
    SET_MODEL_COPY_DETAILS(state, data) {
      state.scenarioModelCopyDetails = data;
    },
    SET_MODEL_COPY_LIST(state, data) {
      state.modelCopyList = data;
    },
    SET_FORM_DATA(state, data) {
      state.formData = data;
    },
    SET_MODEL_NAME(state, data) {
      let newData = { ...state.formData };

      newData.name = data;

      state.formData = newData;
    },
    SET_MODEL_SHORT_DESCRIPTION(state, data) {
      let newData = { ...state.formData };

      newData.short_description = data;

      state.formData = newData;
    },
    SET_MODEL_COPY(state, data) {
      state.modelToCopy = data;
    },
    SET_MODEL_SCENARIO_OPTIONS(state, data) {
      state.scenarioOptions = data;
    }
  },
  actions: {
    updateName({ state }, { context }) {
      let dataToPost = { name: state.formData.name, short_description: state.formData.short_description };

      let putUrl = `${models}/${state.formData.id}/`;
      return context.$http.patch(putUrl, dataToPost);
    },
    fetchModelCopyDetails({ commit }, { context }) {
      let getUrl = `${process.env.VUE_APP_URL}/api/v1/model/copy-trackers/`;
      context.$http.get(getUrl)
        .then(response => {
            commit("SET_MODEL_COPY_LIST", response.data);
        }).catch(error => {
            console.error("Error fetching model copy trackers:", error);
        });
    },
  }
}
